import { useEffect, useState } from "react";

// 路径路由：URL 直接定位页面（如 /login、/holding、/stocks），刷新保持当前页面与查询参数
export function useRoute(): string {
  const [path, setPath] = useState(() => location.pathname || "/");

  useEffect(() => {
    const onPopState = () => setPath(location.pathname || "/");
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  return path;
}

// 当前 URL 查询参数（随浏览器前进/后退更新）
export function useSearchParams(): URLSearchParams {
  const [params, setParams] = useState(() => new URLSearchParams(location.search));

  useEffect(() => {
    const onPopState = () => setParams(new URLSearchParams(location.search));
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  return params;
}

// 页面导航：pushState 改 URL，replace=true 时不产生历史记录（用于重定向）
export function navigate(path: string, replace = false) {
  // 已处于目标 URL（含查询参数）时不做任何操作
  if (location.pathname + location.search === path) return;
  if (replace) {
    history.replaceState(null, "", path);
  } else {
    history.pushState(null, "", path);
  }
  // pushState/replaceState 不触发 popstate，手动派发以更新路由状态
  window.dispatchEvent(new PopStateEvent("popstate"));
}

// 更新当前 URL 的查询参数（值传 null/空串则删除该参数），产生一条历史记录
export function updateSearchParams(updates: Record<string, string | null>) {
  const params = new URLSearchParams(location.search);
  for (const [key, value] of Object.entries(updates)) {
    if (value == null || value === "") params.delete(key);
    else params.set(key, value);
  }
  const qs = params.toString();
  const url = qs ? `${location.pathname}?${qs}` : location.pathname;
  history.pushState(null, "", url);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
